import config from './config';

export const getAuth0ContinueUrl = (state: string): string =>
  `https://${config.domain}/continue?state=${encodeURIComponent(state)}`;
